import { ReceiptIcon } from './ReceiptIcon';

/**
 * author: Michael Irigoyen
 * id EEB46F1F-4996-4B65-A1C6-70DC4D38C34E
 * name receipt
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/receipt.svg
 * tags
 * - Banking 
 */
export const SwatchIcon = ReceiptIcon;
export default SwatchIcon